import { useEffect, useRef } from "react";

export default function useDismissOnOutside(setOpen) {
  const wrapRef = useRef(null);

  useEffect(() => {
    const closeOutside = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) setOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", closeOutside);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [setOpen]);

  return wrapRef;
}
